import dayjs from 'dayjs';

const ApplicationHelper = {
	canEditApplication({ application }) {
		if (application && application.is_draft) {
			return true;
		}
		if (!application || !application.trips || application.trips.length === 0) {
			return false;
		}
		if (application.date_of_trip && dayjs(application.date_of_trip).endOf('day').isBefore(dayjs())) {
			return false;
		}

		for (let i = 0; i < application.trips.length; i++) {
			const applicationTrip = application.trips[i];
			const canEditApplicationTrip = ApplicationHelper.canEditApplicationTrip({
				application,
				applicationTrip
			});

			// if one of the trips is editable, the application is editable
			if (canEditApplicationTrip) {
				return true;
			}
		}

		// all trips cannot be edited, thus application should not be editable
		return false;
	},
	canEditApplicationTrip({ applicationTrip }) {
		if (!applicationTrip) {
			return false;
		}

		// creating
		if (!applicationTrip.application_trip_id) {
			return true;
		}

		if (['cancelled', 'rejected'].indexOf(applicationTrip.status) !== -1) {
			return false;
		}

		// cannot edit if less than 1 hours
		if (dayjs(applicationTrip.time_of_departure).diff(dayjs(), 'hour') < 1) {
			return false;
		}

		return true;
	}
};

export default ApplicationHelper;
